import { render, staticRenderFns } from "./Instro.vue?vue&type=template&id=5cb3d6bb&scoped=true"
import script from "./Instro.vue?vue&type=script&lang=js"
export * from "./Instro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3d6bb",
  null
  
)

export default component.exports